<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('report_purchase')}} [{{title}}]</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
                <i class="fa fa-arrow-circle-o-left"></i>
                {{ $t('back') }}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="onPrint">
                <i class="fa fa-print"></i>
                {{$t('print')}}
            </button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('export_excel')}}
            </button>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <div style="display: flex; gap: 8px;">
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==1}" @click="onSection(1, $t('purchase_summary'))"><i class="fa fa-line-chart" aria-hidden="true"></i> {{$t('purchase_summary')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==2}" @click="onSection(2, $t('purchase_operation'))"><i class="fa fa-download" aria-hidden="true"></i> {{$t('purchase_operation')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==3}" @click="onSection(3, $t('purchase_operation_detail'))"><i class="fa fa-opera" aria-hidden="true"></i> {{$t('purchase_operation_detail')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==4}" @click="onSection(4, $t('purchase_operation_monthly'))"><i class="fa fa-clock-o" aria-hidden="true"></i> {{$t('purchase_operation_monthly')}}</button>
                                <button type="button" class="btn btn-outline-primary btn-sm" :class="{active:section==5}" @click="onSection(5, $t('purchase_operation_yearly'))"><i class="fa fa-random" aria-hidden="true"></i> {{$t('purchase_operation_yearly')}}</button>
                            </div>
                        </div>
                    </div>
                    <br>
                    <keep-alive>
                        <component :is="currentTabComponent" @change="onChange"></component>
                    </keep-alive>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SummarySection from './SummarySection.vue';
    import OperationSection from './OperationSection.vue';
    import PODetailSection from './PODetailSection.vue';
    import MonthlySection from './MonthlySection.vue';
    import YearlySection from './YearlySection.vue';
    export default {
        components: {
            'section_1': SummarySection,
            'section_2': OperationSection,
            'section_3': PODetailSection,
            'section_4': MonthlySection,
            'section_5': YearlySection,
        },
        data() {
            return {
                section: 1,
                title: this.$t('purchase_summary'),
                filter1: {},
                filter2: {},
                filter3: {},
                filter4: {},
                filter5: {},
            }
        },
        methods: {
            onSection(n, text) {
                this.section = n;
                this.title = text;
            },
            onPrint() {
                let link = '';
                if (this.section === 1) {
                    link = '/print-purchase-summary?year=' + this.filter1.Year + '&month=' + this.filter1.Month + '&CompanyId=' + this.$store.state.company.Id;
                } else if (this.section === 2) {
                    link = '/print-purchase-operation?year=' + this.filter2.Year + '&month=' + this.filter2.Month + '&CompanyId=' + this.$store.state.company.Id;
                } else if (this.section === 3) {
                    link = '/print-purchase-detail?year=' + this.filter3.Year + '&month=' + this.filter3.Month + '&CompanyId=' + this.$store.state.company.Id;
                } else if (this.section === 4) {
                    link = '/print-purchase-monthly' + '?CompanyId=' + this.$store.state.company.Id;
                } else if (this.section === 5) {
                    link = '/print-purchase-yearly' + '?CompanyId=' + this.$store.state.company.Id;
                } else {
                    return;
                }
                window.open(link, '_blank');
            },
            exportExcel() {
                let link = '';
                let fileName = '';
                let loading = this.$loading.show();
                const query = {
                    Year: '',
                    Month: '',
                    CompanyId: this.$store.state.company.Id
                };
                if (this.section === 1) {
                    link = 'report/purchase/summaries/export/excel';
                    fileName = 'report-purchase-summaries.xlsx';
                    query.Year = this.filter1.Year;
                    query.Month = this.filter1.Month;
                } else if (this.section === 2) {
                    link = 'report/purchase/operations/export/excel';
                    fileName = 'report-purchase-operations.xlsx';
                    query.Year = this.filter2.Year;
                    query.Month = this.filter2.Month;
                } else if (this.section === 3) {
                    link = 'report/purchase/detail/export/excel';
                    fileName = 'report-purchase-detail.xlsx';
                    query.Year = this.filter3.Year;
                    query.Month = this.filter3.Month;
                } else if (this.section === 4) {
                    link = 'report/purchase/monthly/export/excel';
                    fileName = 'report-purchase-monthly.xlsx';
                    query.Year = this.filter4.Year;
                    query.Month = this.filter4.Month;
                } else if (this.section === 5) {
                    link = 'report/purchase/yearly/export/excel';
                    fileName = 'report-purchase-yearly.xlsx';
                    query.Year = this.filter5.Year;
                    query.Month = this.filter5.Month;
                }
                this.$api()({
                    url: this.$base() + link,
                    method: 'post',
                    data: query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                }).finally(function () { loading.hide(); });
            },
            onChange(sender, evt) {
                if (sender === 1) this.filter1 = evt;
                else if (sender === 2) this.filter2 = evt;
                else if (sender === 3) this.filter3 = evt;
            }
        },
        computed: {
            currentTabComponent() {
                return 'section_' + this.section;
            }
        }
    }
</script>
